import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  primaryColor: string;
  secondaryColor: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
    caption: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '22px',
      display: 'flex',
      alignItems: 'center',
      color: theme.oysterTheme.charcoal,
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(1),
    },
    speiInfo: {
      '& > .MuiBox-root:first-child': {
        paddingBottom: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderBottom: `1px solid ${theme.oysterTheme.pearl}`,
      },
    },
    label: {
      fontWeight: 600,
      fontSize: 10,
      lineHeight: '12px',
      color: theme.oysterTheme.charcoal,
    },
    value: {
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '17px',
      color: theme.oysterTheme.charcoal,
    },
    copyIcon: {
      '& svg path': {
        fill: ({ secondaryColor }: StyleProps) => secondaryColor,
      },
    },
  }),
);

export default useStyles;
